import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import { GSM_ERROR_NAME } from '@app/shared/gsm/gsm-ui-lib-ng-shared/src/lib/gsm-error';
import { GsmErrorService } from '@app/shared/gsm/gsm-ui-lib-ng-shared/src/lib/gsm-error.service';
import { ErrorReportService } from '../services/data/error-report.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  private injector = inject(Injector);


  private readonly EXEMPT_STAGE = [
    'dev',
    'pre-dev',
    'local'
  ];

  public handleError(error: Error): void {

    const errorService = this.injector.get(GsmErrorService);

    const err = (error as any).rejection || error;
    if (err.name === GSM_ERROR_NAME) {
      errorService.catchError(err);
      return;
    }

    try {
      let NODE_ENV = '';
      try {
        NODE_ENV = process.env.NODE_ENV;
      } catch {
      }
      if (this.EXEMPT_STAGE
        .findIndex(v => v === NODE_ENV.trim()
          .toLowerCase()) === -1) {
        const reportService = this.injector.get(ErrorReportService);
        reportService.scheduleErrorReport(error);
      }
    } catch (e) {
      console.warn(`Failed to send error report`, e);
    } finally {
      super.handleError(error);
    }
  }

}
